import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Wrapper = styled.div`
    position: relative;
`;

export const YatLink = styled(Link)`
    height: 48px;
    display: inline-flex;

    border-radius: 24px;

    transition: box-shadow 0.2s ease-in-out;

    &:hover {
        box-shadow: 0 0 10px rgba(82, 61, 241, 0.6);
    }
`;
